import { clsx } from 'clsx';
import type { ReactNode } from 'react';

type Variant = 'default' | 'accent' | 'danger' | 'success' | 'channel';

const VARIANT: Record<Variant, string> = {
  default: 'bg-fill-2 border border-line text-fg-secondary',
  accent:  'bg-accent-bg border border-accent-border text-accent',
  danger:  'bg-danger-bg border border-danger-border text-danger',
  success: 'bg-success-bg border border-success-border text-success',
  channel: 'bg-fill-2 border border-line text-fg-secondary',
};

export interface TagProps {
  variant?: Variant;
  dot?: boolean | 'pulse';
  closable?: boolean;
  onClose?: () => void;
  className?: string;
  children: ReactNode;
}

export function Tag({
  variant = 'default',
  dot,
  closable,
  onClose,
  className,
  children,
}: TagProps) {
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md text-xs font-semibold',
        VARIANT[variant],
        className,
      )}
    >
      {dot && (
        <span
          className={clsx(
            'inline-block w-1.5 h-1.5 rounded-full bg-current',
            dot === 'pulse' && 'animate-pulse',
          )}
        />
      )}
      {children}
      {closable && (
        <button
          type="button"
          onClick={onClose}
          className="ml-1 opacity-60 hover:opacity-100 text-current"
          aria-label="Close"
        >
          ×
        </button>
      )}
    </span>
  );
}
